import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Unit } from '../../models/unit';
import { UnitService } from '../../services/unit.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { SubDepartmentService } from '../../services/subdepartment.service';
import { SubDepartment } from '../../models/subdepartment';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { DivisionService } from '../../services/division.service';
import { Division } from '../../models/division';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { DepartmentService } from '../../services/department.service';
import { Department } from '../../models/department';

@Component({
  selector: 'app-unit',
  templateUrl: './unit.component.html',
  styleUrls: ['./unit.component.css']
})
export class UnitComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerUnit: PageHeader;
  entity: Unit = new Unit();
  selectedUnit: Unit = new Unit();
  editingEntity: Unit = new Unit();
  units: any;
  unitColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  subdepartments: Array<SubDepartment> = [];
  selectedSubDepartment: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  company: Array<Company> = [];
  selectedCompany: any;
  divisions: Array<Division> = [];
  selectedDivision: any;
  locations: Array<Location> = [];
  selectedLocation: any;
  departments: Array<Department> = [];
  selectedDepartment: any;
  opened: boolean = false;
  details: any;
  constructor(
    private _unitService: UnitService,
    private _subdepartmentService: SubDepartmentService,
    private _divisionService: DivisionService,
    private _companyService: CompanyService,
    private _locationService: LocationService,
    private _departmentService: DepartmentService,
    private _employeeService: EmployeeService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerUnit = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.units = [];
    this.getAllUnit();
  }
    ngAfterViewInit(): void {
    this.unitColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },
      { field: "UnitName", title: 'Unit', filter: true, sortable: true, width: 100 },
      { field: "UnitPrefix", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "EmployeeName", title: 'Unit Head', filter: true, sortable: true, width: 100 },
      // { field: "CompanyName", title: 'Company', filter: true, sortable: true, width: 100 },
      // { field: "DivisionName", title: 'Division', filter: true, sortable: true, width: 100 },
      // { field: "LocationName", title: 'Location', filter: true, sortable: true, width: 100 },
      // { field: "DepartmentName", title: 'Department', filter: true, sortable: true, width: 100 },
       { field: "SubDepartmentName", title: 'Sub Department', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }

  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._unitService.getAllUnit('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Unit>) => {
      this.units = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }
  getAllDivisions(filter: string) {
    this._divisionService.getAllDivisions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Division>) => {
      this.divisions = data;
    })
  }
  getAllLocations(filter: string) {
    this._locationService.getAllLocations(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Location>) => {
      this.locations = data;
    })
  }
  getAllDepartments(filter: string) {
    this._departmentService.getAllDepartment(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Department>) => {
      this.departments = data;
    })
  }
  // getAllDepartmentsbySubdepartment(SubdepartmentID: string) {
  //   this._departmentService.getAllDepartmentsbySubdepartment(SubdepartmentID).subscribe((data: Array<Department>) => {
  //     this.departments = data;
  //     this.selectedDepartment = { Department_Id:data[0].Department_Id, DepartmentName:data[0].DepartmentName };
  //   })
  // }
  SubDepartmentchanged(state: any) {
 
    this.entity.Department_Id = '';
    this.entity.DepartmentName = '';
    this.selectedDepartment = { Department_Id: '', DepartmentName:'' };
        
    
      // this.getAllState(this.entity.State_Id);
    //  this.getAllDepartmentsbySubdepartment(this.entity.SubDepartment_Id);
    
  }
  getAllSubDepartments(filter: string) {
    this._subdepartmentService.getAllSubDepartment(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<SubDepartment>) => {
      this.subdepartments = data;
    })
  }
  getAllEmployees(filter: string) {
    this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
      this.employees = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      //0 FOR ALL RECORD FROM TABLE INCLUDING ACTIVE AND INACTIVE.
      this._unitService.getAllUnit(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((units: Array<Unit>) => {
        this.units = {
          data: units,
          total: units[0] ? units[0].TotalCount : 0
        }
      });
    }
  }
  getAllUnit() {
    this._unitService.getAllUnit('', Number(this.defaultPageSize), 1, 0, 0).subscribe((units: Array<Unit>) => {
      this.units = {
        data: units,
        total: units[0] ? units[0].TotalCount : 0
      }
    })
  };
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._unitService.deleteUnit(this.selectedUnit.Unit_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearUnit();
            this.getAllUnit();
          },
          )
        }
      }
    });
  }
  initPageHeader(): PageHeader {
    let headerUnit = new PageHeader();
    headerUnit.PageCaption = "Unit";
    headerUnit.IconClass = "bi bi-shield-shaded";
    return headerUnit;
  }
  deleteUnit(event: any) {
    if (event.seletedRows[0]) {
      this.selectedUnit.Unit_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Unit",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  addUnit(event: any) {
    this.listView = false;
    this.clearUnit();
    this.getAllCompany('');
    this.getAllDivisions('');
    this.getAllLocations('');
    //this.getAllDepartments('');
    this.getAllSubDepartments('');
    this.getAllEmployees('');
    this.formCaption = "Add Unit";
  }
  editUnit(event: any): void {
    if (event.seletedRows[0]) {
      this._unitService.viewUnit(event.seletedRows[0]).subscribe((units: Array<Unit>) => {
        let editEnity = units[0] ? units[0] : new Unit();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.selectedDivision = { Division_Id: editEnity.Division_Id, DivisionName: editEnity.DivisionName };
          this.selectedLocation = { Location_Id: editEnity.Location_Id, LocationName: editEnity.LocationName };
          this.selectedDepartment = { Department_Id: editEnity.Department_Id, DepartmentName: editEnity.DepartmentName };
          this.selectedSubDepartment = { SubDepartment_Id: editEnity.SubDepartment_Id, SubDepartmentName: editEnity.SubDepartmentName };
          this.selectedEmployee = { Emp_Ref_Id: editEnity.Emp_Ref_Id, EmployeeName: editEnity.EmployeeName };

          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Unit";
          this.getAllCompany('');
          this.getAllDivisions('');
          this.getAllLocations('');
         // this.getAllDepartments('');
          this.getAllSubDepartments('');
          this.entity.EntityMetaData = [
            { FieldName: 'UnitName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Unit Name is required' },
            { FieldName: 'UnitPrefix', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
      
       // {FieldName : 'SubDepartment_Id' , FieldType: FieldType.String, IsMandatory:true, ValidationMessage: 'Sub Department is required'},
       // { FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Unit Head is required' },
        
      //{FieldName : 'Department_Id' , FieldType: FieldType.String, IsMandatory:true, ValidationMessage: ' Department is required'}, 
    ];
        }
      });
    }
  }
  save(event: any): void {
    if(parseInt(this.entity.UnitPrefix)==0)
    {
      this.notification.showWarning('Zero not allowed');
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._unitService.checkDuplication( this.entity.Unit_Id,this.entity.UnitPrefix).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Unit Code already exists');
          this.saveDisabled = false;
        }
        // else {
        //   if (this.entity.Phone.length != 0 && this.entity.Phone.length != 10) {
        //     this.notification.showWarning("Invalid Phone No.");
        //     this.saveDisabled = false;
        //   }
        //   else {
        //     const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //     this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
        //     if (this.emailcheck === false) {
        //       this.notification.showWarning("Email not valid");
        //       this.saveDisabled = false;
        //     }
            else {
              this._unitService.saveUnit(this.entity).subscribe(() => {
                if (this.entity.Unit_Id == '00000000-0000-0000-0000-000000000000') {
                  this.notification.showSuccess('Saved Successfully');
                }
                else {
                  this.notification.showSuccess('Updated Successfully');
                }
                this.listView = true;
                this.clearUnit();
                this.getAllUnit();
              })
            }
          //}
        //}
      });
    }
    else {
      this.saveDisabled = false;
    }
  }
  goToBackTab(): void {
    this.listView=true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  gotoBack(): void {
    this.listView = true;
    this.getAllUnit();
  }
  refreshUnits(event: any): void {
    this.units = [];
    this.getAllUnit();
  }
  clearUnit(): void {
    this.selectedLocation = {};
    this.selectedCompany = {};
    this.selectedDivision = {};
    this.selectedDepartment = {};
    this.selectedSubDepartment = {};
    this.selectedEmployee = {};
    this.entity = new Unit();
    this.saveDisabled = false;
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
 this.entity.Unit_Id=dataItem.Unit_Id;
 this.details =[];
 this._unitService.viewUnit(this.entity.Unit_Id).subscribe((units: Array<Unit>) => {
  this.opened = true;
  this.details = units[0];
  })}

}
